import { render, staticRenderFns } from "./RequestHistory.vue?vue&type=template&id=6a3c8734"
import script from "./RequestHistory.vue?vue&type=script&lang=js"
export * from "./RequestHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports